import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
// import '../../App.css';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';



function CompanyIndex() {
  const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  let companyid = companyId;
  if (isSuperAdmin == true && companyId == superCompanyId) {
    companyid = 0;
  }


  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId, token, logout]);

  useEffect(() => {
    fetchData('CompanyApi', `/${companyid}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Company Details:', error);
      });
  }, []);

  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <div className='w-full mb-2 flex'>
        <h4 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Company</h4>
        {/* {isSuperAdmin && companyId == superCompanyId && (*/}

        <Tooltip title="Create New Company">
          <Link to="/CompanyCreate" className="inline-block">
            <Button style={{ fontWeight: 'bolder'}}>
              <AddIcon style={{ fontWeight: 'bolder' }} /> Create

            </Button>

          </Link>
        </Tooltip>
        {/* )} */}
      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#008080' }}>
              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', padding: '7px', color: 'whitesmoke', fontWeight: 'bold' }}>Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', padding: '7px', color: 'whitesmoke', fontWeight: 'bold' }}>Company Code</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', padding: '7px', color: 'whitesmoke', fontWeight: 'bold' }}>Contact Number 1</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', padding: '7px', color: 'whitesmoke', fontWeight: 'bold' }}>Contact Number 2</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', padding: '7px', color: 'whitesmoke', fontWeight: 'bold' }}>Email</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', padding: '7px', color: 'whitesmoke', fontWeight: 'bold' }}>GST Number</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', padding: '7px', color: 'whitesmoke', fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: 'rgba(38, 166, 154, 0.3)' }}>
              {data.map(item => (
                <TableRow key={item.Id}>
                  <TableCell style={{ color: 'black', fontWeight: 'bold' }}>{item.Name}</TableCell>
                  <TableCell style={{ color: 'black', fontWeight: 'bold' }}>{item.CompanyCode}</TableCell>
                  <TableCell style={{ color: 'black', fontWeight: 'bold' }}>{item.ContactNumber1}</TableCell>
                  <TableCell style={{ color: 'black', fontWeight: 'bold' }}>{item.ContactNumber2}</TableCell>
                  <TableCell style={{ color: 'black', fontWeight: 'bold' }}>{item.Email}</TableCell>
                  <TableCell style={{ color: 'black', fontWeight: 'bold' }}>{item.GSTNumber}</TableCell>
                  <TableCell style={{ color: 'black', fontWeight: 'bold' }}>
                    <Link to={`/companyEdit/${item.ID}`}>
                      <IconButton>
                        <EditIcon style={{color:'blueviolet'}}/>
                      </IconButton>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>

  );
}

export default CompanyIndex;

